const APP_STORE_URL = 'https://apps.apple.com/us/app/horsestat/id6807986968';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.horsestat.app';

function AppleIcon() {
  return (
    <svg className="store-badge__icon store-badge__apple" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M17.1 12.5c0-2.6 2.1-3.8 2.2-3.9-1.2-1.8-3.1-2-3.8-2-1.6-.2-3.2 1-4 1-1 0-2.5-1-3.9-.9-2 .1-3.8 1.2-4.8 3-2.1 3.6-.5 8.9 1.5 11.8 1 1.4 2.1 3 3.6 2.9 1.5-.1 2.1-.9 3.9-.9 1.8 0 2.4.9 4 .9 1.7 0 2.7-1.4 3.7-2.9 1.1-1.7 1.6-3.4 1.6-3.5-.1 0-4-.9-4-5.5ZM14.4 5c.8-1 1.4-2.5 1.2-4-1.2 0-2.7.8-3.6 1.8-.8.9-1.5 2.4-1.3 3.9 1.4.1 2.8-.7 3.7-1.7Z" />
    </svg>
  );
}

function PlayStoreIcon() {
  return (
    <svg className="store-badge__icon store-badge__play" viewBox="0 0 26 29" aria-hidden="true">
      <path fill="#00d7fe" d="M1.2 1.1 15.8 14.5 1.3 28c-.5-.5-.8-1.2-.8-2.1V3.2c0-.8.2-1.5.7-2.1Z" />
      <path fill="#ffce00" d="m20.5 10.2-4.7 4.3L1.2 1.1c.7-.7 1.8-.8 2.9-.2l16.4 9.3Z" />
      <path fill="#ff3a44" d="M20.5 18.8 4.1 28.1c-1.1.6-2.1.5-2.8-.1l14.5-13.5 4.7 4.3Z" />
      <path fill="#00f076" d="M24.2 12.3c1.7 1 1.7 3.3 0 4.3l-3.7 2.2-4.7-4.3 4.7-4.3 3.7 2.1Z" />
    </svg>
  );
}

function StoreButtons({ className = '' }) {
  return (
    <div className={`store-buttons ${className}`.trim()}>
      <a className="store-badge" href={APP_STORE_URL} aria-label="Download on the App Store">
        <AppleIcon />
        <span className="store-badge__text">
          <small>Download on the</small>
          App Store
        </span>
      </a>
      <a className="store-badge" href={PLAY_STORE_URL} aria-label="Get it on Google Play">
        <PlayStoreIcon />
        <span className="store-badge__text">
          <small>Get it on</small>
          Google Play
        </span>
      </a>
    </div>
  );
}

export default StoreButtons;
